// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".disclaimer-content__wrapper[data-v-2277afba]{text-align:left;font-size:14px;line-height:18px}", ""]);
// Exports
module.exports = exports;
